exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".profile-textfield{margin:-10px 0 -20px}.listing .default{margin-top:10px}.listing .mdl-cell{padding:0 10px}[tooltip]{position:relative}[tooltip]:after,[tooltip]:before{position:absolute;z-index:10;top:10px;left:20px;opacity:0;transition:opacity .3s ease;pointer-events:none}[tooltip]:after{content:attr(tooltip);padding:8px 15px;border-radius:4px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;border:1px solid #f19100;background-color:#fff;color:#424242}[tooltip]:before{content:\"\";border:5px solid transparent;border-top-color:#f19100}[tooltip]:hover:after,[tooltip]:hover:before{opacity:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js!./~/vue-loader/lib/selector.js?type=style&index=0!./~/eslint-loader!./src/admin/pages/Labels.vue
// module id = 260
// module chunks = 0